import React from 'react';
import { Container, Title, AccountItems, AccountItem } from './styles';
import ServiceUrl from '../../utils/ServiceUrl';

export default () => {
  const NOTHS_BASE_URL = ServiceUrl.public('noths');

  const myAccountMenuItems = [
    {
      title: 'my details',
      url: `${NOTHS_BASE_URL}/user`,
    },
    {
      title: 'my orders',
      url: `${NOTHS_BASE_URL}/user/orders?secure=true`,
    },
    {
      title: 'my calendar',
      url: `${NOTHS_BASE_URL}/calendar/events`,
    },
    {
      title: 'my wish list',
      url: `${NOTHS_BASE_URL}/user/wish-list`,
    },
    {
      title: 'my funds',
      url: `${NOTHS_BASE_URL}/user/account`,
    },
    {
      title: 'my\u00a0marketing preferences',
      url: '#',
      active: true,
    },
    {
      title: 'sign out',
      url: `${NOTHS_BASE_URL}/session/destroy`,
    },
  ];

  return (
    <Container>
      <Title>MY ACCOUNT</Title>
      <AccountItems>
        {myAccountMenuItems.map(item => (
          <AccountItem key={item.title.split(' ').join('-')}>
            <a className={item.active ? 'active' : ''} href={item.url}>
              {item.title}
            </a>
          </AccountItem>
        ))}
      </AccountItems>
    </Container>
  );
};
